import React from 'react';
import axios from 'axios';

import { useTimeModal } from './TimeModal/TimeModalContext';

const InfoBlock = () => {
    const { openTimeModal } = useTimeModal();
    const [infoMessage, setInfoMessage] = React.useState('');

    React.useEffect(() => {
        axios.get('/api/info-message')
        .then(response => {
            if (response.data.length) {
                setInfoMessage(response.data[0].message);
            }
        })
        .catch(error => {
            console.error('Ошибка при получении информационного сообщения:', error);
            openTimeModal(`Не удалось загрузить информационное сообщение:  ${error.response?.data.message || error.message}`, 'error');
        })
    }, []);

    return (
        infoMessage && 
        <div className='infoBlock'>
            <a>{infoMessage}</a>
        </div>
    )
}

export default InfoBlock;